// src/App.js
import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import Ordenes from './Ordenes';
import OrdenNuevoCliente from './OrdenNuevoCliente';
import OrdenClienteExistente from './OrdenClienteExistente';

const naranja = '#f97316';
const negro = '#111827';
const grisFondo = '#f3f4f6';
const blanco = '#ffffff';
const borde = '#e5e7eb';

function App() {
  const [session, setSession] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mensaje, setMensaje] = useState('');

  const [enTaller, setEnTaller] = useState(false);
  const [vistaPanel, setVistaPanel] = useState('cliente'); // cliente | nuevo_cliente_orden | orden_cliente

  useEffect(() => {
    const init = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      setSession(session);
    };

    init();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMensaje('');

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setMensaje('Credenciales inválidas o error al ingresar.');
    } else {
      setMensaje('');
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setSession(null);
    setEnTaller(false);
    setVistaPanel('cliente');
  };

  const handleEntrarTaller = () => {
    setEnTaller(true);
    setVistaPanel('cliente');
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: grisFondo }}>
      {/* HEADER */}
      <header
        style={{
          backgroundColor: negro,
          color: 'white',
          padding: '12px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <img
            src="/fescanlogo.png"
            alt="FeScan"
            style={{ width: 40, height: 40, borderRadius: 8 }}
          />
          <div>
            <div style={{ fontWeight: 700, fontSize: 20 }}>FeScan Taller</div>
            <div style={{ fontSize: 12, color: '#d1d5db' }}>
              Gestión de clientes, vehículos y órdenes
            </div>
          </div>
        </div>

        {session && (
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 12, color: '#d1d5db' }}>Conectado como</div>
            <div style={{ fontSize: 14 }}>{session.user?.email}</div>
            <button
              onClick={handleLogout}
              style={{
                marginTop: 6,
                padding: '4px 10px',
                fontSize: 12,
                borderRadius: 999,
                border: '1px solid #fef3c7',
                backgroundColor: 'transparent',
                color: '#fef3c7',
                cursor: 'pointer',
              }}
            >
              Cerrar sesión
            </button>
          </div>
        )}
      </header>

      {/* CONTENIDO */}
      <main
        style={{
          padding: 24,
          maxWidth: 1000,
          margin: '0 auto',
        }}
      >
        {/* LOGIN */}
        {!session && (
          <section
            style={{
              backgroundColor: blanco,
              borderRadius: 12,
              padding: 24,
              marginTop: 24,
              border: `1px solid ${borde}`,
            }}
          >
            <h2 style={{ marginTop: 0, marginBottom: 12, color: negro }}>
              Iniciar sesión
            </h2>
            <p style={{ marginBottom: 12 }}>
              Ingresa tu correo y contraseña para acceder al panel FeScan.
            </p>
            <form onSubmit={handleLogin}>
              <div style={{ marginBottom: 8 }}>
                <input
                  type="email"
                  placeholder="tu@correo.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    padding: '8px 10px',
                    borderRadius: 8,
                    border: `1px solid ${borde}`,
                    minWidth: 260,
                    marginRight: 8,
                  }}
                  required
                />
              </div>
              <div style={{ marginBottom: 12 }}>
                <input
                  type="password"
                  placeholder="Contraseña"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{
                    padding: '8px 10px',
                    borderRadius: 8,
                    border: `1px solid ${borde}`,
                    minWidth: 260,
                    marginRight: 8,
                  }}
                  required
                />
              </div>
              <button
                type="submit"
                style={{
                  padding: '8px 14px',
                  borderRadius: 999,
                  border: 'none',
                  backgroundColor: naranja,
                  color: 'white',
                  cursor: 'pointer',
                  fontWeight: 600,
                }}
              >
                Entrar
              </button>
            </form>
            {mensaje && (
              <p style={{ marginTop: 10, color: '#b91c1c' }}>{mensaje}</p>
            )}
          </section>
        )}

        {/* PANTALLA "ENTRAR A TALLER" */}
        {session && !enTaller && (
          <section
            style={{
              backgroundColor: blanco,
              borderRadius: 12,
              padding: 24,
              marginTop: 24,
              border: `1px solid ${borde}`,
              textAlign: 'center',
            }}
          >
            <h2 style={{ marginTop: 0, marginBottom: 16, color: negro }}>
              Bienvenido a FeScan
            </h2>
            <p style={{ marginBottom: 16 }}>
              Presiona el botón para entrar al panel del taller.
            </p>
            <button
              onClick={handleEntrarTaller}
              style={{
                padding: '10px 18px',
                borderRadius: 999,
                border: 'none',
                backgroundColor: naranja,
                color: 'white',
                cursor: 'pointer',
                fontWeight: 700,
                fontSize: 15,
              }}
            >
              Entrar a taller FeScan
            </button>
          </section>
        )}

        {/* PANEL TALLER */}
        {session && enTaller && (
          <section
            style={{
              backgroundColor: blanco,
              borderRadius: 12,
              padding: 24,
              marginTop: 24,
              border: `1px solid ${borde}`,
            }}
          >
            {/* Barra superior: Volver + Tabs */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 16,
              }}
            >
              <button
                onClick={() => setEnTaller(false)}
                style={{
                  padding: '6px 12px',
                  borderRadius: 999,
                  border: `1px solid ${borde}`,
                  backgroundColor: 'white',
                  color: negro,
                  cursor: 'pointer',
                  fontSize: 13,
                }}
              >
                ← Volver al inicio
              </button>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 12,
                  borderBottom: `1px solid ${borde}`,
                  paddingBottom: 8,
                  flex: 1,
                }}
              >
                {[
                  { id: 'cliente', label: 'Cliente' },
                  { id: 'nuevo_cliente_orden', label: 'Cliente nuevo + orden' },
                  { id: 'orden_cliente', label: 'Nueva orden a cliente' },
                ].map((tab) => {
                  const activo = vistaPanel === tab.id;
                  return (
                    <button
                      key={tab.id}
                      onClick={() => setVistaPanel(tab.id)}
                      style={{
                        padding: '6px 16px',
                        borderRadius: 999,
                        border: activo ? 'none' : `1px solid ${naranja}`,
                        backgroundColor: activo ? naranja : 'white',
                        color: activo ? 'white' : naranja,
                        cursor: 'pointer',
                        fontSize: 13,
                        fontWeight: 600,
                        boxShadow: activo
                          ? '0 1px 3px rgba(0,0,0,0.15)'
                          : 'none',
                        transition: 'all 0.15s ease',
                      }}
                    >
                      {tab.label}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* CONTENIDO SEGÚN TAB, EN CARDS */}
            {vistaPanel === 'cliente' && (
              <div
                style={{
                  backgroundColor: '#f9fafb',
                  borderRadius: 12,
                  padding: 16,
                  border: `1px solid ${borde}`,
                }}
              >
                <Ordenes />
              </div>
            )}

            {vistaPanel === 'nuevo_cliente_orden' && (
              <div
                style={{
                  backgroundColor: '#f9fafb',
                  borderRadius: 12,
                  padding: 16,
                  border: `1px solid ${borde}`,
                }}
              >
                <OrdenNuevoCliente />
              </div>
            )}

            {vistaPanel === 'orden_cliente' && (
              <div
                style={{
                  backgroundColor: '#f9fafb',
                  borderRadius: 12,
                  padding: 16,
                  border: `1px solid ${borde}`,
                }}
              >
                <OrdenClienteExistente />
              </div>
            )}
          </section>
        )}
      </main>
    </div>
  );
}

export default App;
